import React from 'react';
import Navbar from '../../../components/Navbar';
import Footer from '../../../components/Footer';
import Copyright from '../../../components/Copyright';
import CustomerOnboarding from './CustomerOnboarding';

export default function Blog() {
  return (
    <>
        <Navbar />
        <CustomerOnboarding />
        <Footer />
        <Copyright />
    </>
  )
}